/**
 * Curated cities for "Book now" lead routing.
 * Values are sent as `inquirer_city` and compared (after normalization + aliases) to `storelist.businessDetails.city`.
 * Keep names stable so they match what vendors enter in store address (city segment).
 */

export const BOOKING_CITY_OPTIONS = [
  "Agartala",
  "Agra",
  "Ahmedabad",
  "Aizawl",
  "Ajmer",
  "Amritsar",
  "Aurangabad",
  "Balasore",
  "Bareilly",
  "Bengaluru",
  "Bhopal",
  "Bhubaneswar",
  "Chandigarh",
  "Chennai",
  "Coimbatore",
  "Cuttack",
  "Dehradun",
  "Delhi",
  "Dhanbad",
  "Faridabad",
  "Ghaziabad",
  "Goa",
  "Gurgaon",
  "Guwahati",
  "Gwalior",
  "Howrah",
  "Hubballi",
  "Hyderabad",
  "Imphal",
  "Indore",
  "Jabalpur",
  "Jaipur",
  "Jammu",
  "Jamshedpur",
  "Jodhpur",
  "Kalyan",
  "Kanpur",
  "Kochi",
  "Kolkata",
  "Kozhikode",
  "Lucknow",
  "Ludhiana",
  "Madurai",
  "Mangaluru",
  "Meerut",
  "Mumbai",
  "Mysuru",
  "Nagpur",
  "Nashik",
  "Navi Mumbai",
  "Noida",
  "Patna",
  "Pimpri-Chinchwad",
  "Pondicherry",
  "Pune",
  "Raipur",
  "Rajkot",
  "Ranchi",
  "Shillong",
  "Shimla",
  "Siliguri",
  "Solapur",
  "Srinagar",
  "Surat",
  "Thane",
  "Thiruvananthapuram",
  "Thrissur",
  "Tiruchirappalli",
  "Udaipur",
  "Vadodara",
  "Varanasi",
  "Vijayawada",
  "Visakhapatnam",
].sort((a, b) => a.localeCompare(b));

/**
 * Map listing / legacy vendor spellings to a canonical option value from BOOKING_CITY_OPTIONS.
 */
export function matchBookingCityOption(raw) {
  const t = String(raw || "").trim();
  if (!t) return "";
  const lower = t.toLowerCase().replace(/\s+/g, " ");
  const exact = BOOKING_CITY_OPTIONS.find((c) => c.toLowerCase() === lower);
  if (exact) return exact;

  const aliases = new Map([
    ["bombay", "Mumbai"],
    ["bangalore", "Bengaluru"],
    ["vizag", "Visakhapatnam"],
    ["calcutta", "Kolkata"],
    ["madras", "Chennai"],
    ["baroda", "Vadodara"],
    ["trivandrum", "Thiruvananthapuram"],
    ["cochin", "Kochi"],
    ["calicut", "Kozhikode"],
    ["poona", "Pune"],
    ["gurugram", "Gurgaon"],
  ]);

  const canonical = aliases.get(lower);
  if (canonical) {
    const match = BOOKING_CITY_OPTIONS.find((c) => c === canonical);
    if (match) return match;
  }

  return "";
}
